import o from "ramda/es/o";
import * as basicFacade from '../../../facade';
import { mergeActions, mergeWithResolveValueWithState } from '../../../facade/utils';
import logout from '../../logout';
import { authHeaderFactory } from '../../utils';
/**
 * REST API facade decorator, that adds authorization header with access token.
 *
 * By default is uses **getAccessToken** selector from *@gef-ui/redux-common/selectors/appContext*
 * and auth header key is 'X-Authorization'
 *
 * You can overwrite these using params tokenSelector and authHeaderName in your action
 *
 * @documented
 * @category facadeDecorator
 *
 * @param wrapped
 * @returns wrapped action
 */ export const withAccessToken = (wrapped)=>({ additionalHeaders = {}, tokenSelector, authHeaderName, ...other })=>wrapped({
            additionalHeaders: mergeWithResolveValueWithState(authHeaderFactory(tokenSelector, authHeaderName), additionalHeaders),
            ...other
        });
/**
 * REST API facade decorator, that adds logout action when unauthorized error.
 *
 * You can specify actions that will be dispatched before logout redirect
 *
 * @documented
 * @category facadeDecorator
 *
 * @param wrapped
 * @returns wrapped action
 */ export const withLogout = (wrapped, logoutAction = logout)=>({ actions = {}, beforeLogout, ...other })=>wrapped({
            actions: {
                ...actions,
                onError: mergeActions(logoutAction(beforeLogout), actions.onError)
            },
            ...other
        });
/**
 * REST API facade decorator, that compose **withLogout** and **withAccessToken** decorators
 *
 * In module @gef-ui/middleware-api/auth/access/facade are available these access decorated actions:
 * - postFormEncoded
 * - postMultipartForm
 * - postApplicationJson
 * - putApplicationJson
 * - patchApplicationJson
 * - getData
 * - postData
 * - deleteData
 *
 * @documented
 * @category facadeDecorator
 *
 * @param wrapped
 * @returns wrapped action
 */ export const withAccess = o(withLogout, withAccessToken);
export const postFormEncoded = withAccess(basicFacade.postFormEncoded);
export const postMultipartForm = withAccess(basicFacade.postMultipartForm);
export const postApplicationJson = withAccess(basicFacade.postApplicationJson);
export const putApplicationJson = withAccess(basicFacade.putApplicationJson);
export const patchApplicationJson = withAccess(basicFacade.patchApplicationJson);
export const getData = withAccess(basicFacade.getData);
export const postData = withAccess(basicFacade.postData);
export const deleteData = withAccess(basicFacade.deleteData);
